import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6 col-md-3" }
const _hoisted_5 = { class: "col-6 col-md-3" }
const _hoisted_6 = { class: "col-6 col-md-3" }
const _hoisted_7 = { class: "col-6 col-md-2" }
const _hoisted_8 = { class: "col-6 col-md-2" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "mb-1 text-muted f12px" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_14 = { class: "text-nowrap" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-12" }

import { onMounted, reactive } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import Paginador from "@/components/Paginador/Index.vue";
import DropdownUsuarios from "@/components/Dropdowns/DropdownUsuarios.vue";
import AutoCompleteClientes from "@/components/AutoCompletes/AutoCompleteClientes.vue";
import * as service from "@/services/logsService";
import { fdataHora } from "@/utils/funcoes";


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const controle = reactive({
  filtros: {
    usuarioId: null,
    clienteId: null,
    pesquisar: null,
    dataInicio: null,
    dataFim: null,
    paginaAtual: 1,
    tamanhoPagina: 10,
  } as service.Filtros,
  itens: [] as service.Log[],
  totalRegistros: 0,
  status: "",
  erro: "",
});

onMounted(() => {
  pesquisar();
});

function pesquisar() {
  controle.status = "Pesquisando...";
  controle.erro = "";
  service.obter(controle.filtros)
    .then(r => {
      controle.itens = r.dados;
      controle.totalRegistros = r.totalRegistros;
      controle.status = "";
    })
    .catch(e => {
      controle.erro = e.message || String(e);
      controle.status = "";
    });
}

function corLinha(tipo: string) {
  if (tipo === "Erro") return "text-danger";
  if (tipo === "LogUsuario") return "text-primary";
  return "";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Logs do Sistema",
      SubTitle: "Auditoria"
    }),
    _createVNode(Notificacao, {
      erro: controle.erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (controle.erro = '')),
      progresso: controle.status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (controle.status = ''))
    }, null, 8, ["erro", "progresso"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("label", null, "Pesquisar (Local ou Descrição)", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              placeholder: "Qualquer parte do texto...",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((controle.filtros.pesquisar) = $event)),
              onInput: pesquisar
            }, null, 544), [
              [_vModelText, controle.filtros.pesquisar]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Cliente", -1)),
            _createVNode(AutoCompleteClientes, {
              modelValue: controle.filtros.clienteId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((controle.filtros.clienteId) = $event)),
              onSelected: pesquisar
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[10] || (_cache[10] = _createElementVNode("label", null, "Usuário", -1)),
            _createVNode(DropdownUsuarios, {
              modelValue: controle.filtros.usuarioId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((controle.filtros.usuarioId) = $event)),
              onChange: pesquisar
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[11] || (_cache[11] = _createElementVNode("label", null, "Data Início", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((controle.filtros.dataInicio) = $event)),
              onChange: pesquisar
            }, null, 544), [
              [_vModelText, controle.filtros.dataInicio]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[12] || (_cache[12] = _createElementVNode("label", null, "Data Fim", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((controle.filtros.dataFim) = $event)),
              onChange: pesquisar
            }, null, 544), [
              [_vModelText, controle.filtros.dataFim]
            ])
          ]),
          _createElementVNode("div", { class: "col-6 col-md-2" }, [
            _createElementVNode("a", {
              class: "btn btn-primary btn-sm mt-4",
              onClick: pesquisar
            }, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("i", { class: "fa fa-search me-1" }, null, -1),
              _createTextVNode(" Pesquisar ", -1)
            ]))])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, "Total: " + _toDisplayString(controle.totalRegistros) + " registro(s)", 1),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("table", _hoisted_13, [
            _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { class: "text-nowrap" }, "Data"),
                _createElementVNode("th", { class: "text-nowrap" }, "Tipo"),
                _createElementVNode("th", null, "Usuário"),
                _createElementVNode("th", null, "Cliente"),
                _createElementVNode("th", null, "Empresa"),
                _createElementVNode("th", null, "Local"),
                _createElementVNode("th", null, "Descrição")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.itens, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(fdataHora)(item.data)), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(["text-nowrap", corLinha(item.tipo)])
                  }, _toDisplayString(item.tipo), 3),
                  _createElementVNode("td", null, _toDisplayString(item.usuarioNome ?? "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.clienteNome ?? "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.empresaNome ?? "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.local ?? "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.descricao), 1)
                ]))
              }), 128)),
              (!controle.itens.length && !controle.status)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("td", {
                      colspan: "7",
                      class: "text-center text-muted"
                    }, "Nenhum log encontrado.", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(Paginador, {
              class: "float-end",
              paginaAtual: controle.filtros.paginaAtual,
              tamanhoPagina: controle.filtros.tamanhoPagina,
              totalRegistros: controle.totalRegistros,
              onOnChange: _cache[7] || (_cache[7] = (el) => {
              controle.filtros.paginaAtual = el.paginaAtual;
              controle.filtros.tamanhoPagina = el.tamanhoPagina;
              pesquisar();
            })
            }, null, 8, ["paginaAtual", "tamanhoPagina", "totalRegistros"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})